import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { HttpService } from '../http.service';
import { GenerateSignedUrlResponse } from '@shared/entities/generateSignedUrlResponse';

@Injectable({
  providedIn: 'root'
})
export class FsSignedUrlService {
  constructor(private httpService: HttpService) {}

  generateSignedUrl(body?: any): Observable<GenerateSignedUrlResponse> {
    const payload = body ?? {};
    return this.httpService.httpPost('fs/signed-url', payload).pipe(
      map((response: any) => {
        return {
          url: response.url,
          httpMethod: response.httpMethod ?? 'PUT',
          expiresInMinutes: response.expiresInMinutes ?? null
        } as GenerateSignedUrlResponse;
      })
    );
  }
}
